var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isCreating
    ? _c(
        "div",
        { staticClass: "h-full bg-gray flex-1 flex flex-center" },
        [
          _c("vue-loading", {
            attrs: {
              type: "spiningDubbles",
              color: "#efad4c",
              size: { width: "100px", height: "100px" },
            },
          }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass:
            "h-full flex-1 bg-gray scroll-y flex flex-column align-items",
        },
        [
          _c("h2", { staticClass: "mx-1" }, [
            _vm._v(_vm._s(_vm.$t("novelCreatePage.title"))),
          ]),
          _c("div", { staticClass: "card flex flex-column" }, [
            _c("div", { staticClass: "px-1 section" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("novelCreatePage.titleInput.label"))),
              ]),
              _c("div", { staticClass: "field-header" }, [
                _c("span", { staticClass: "field-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("novelCreatePage.titleInput.fieldLabel"))
                  ),
                ]),
                _c("span", { staticClass: "char-counter" }, [
                  _vm._v(_vm._s(_vm.title.length) + "/80"),
                ]),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title",
                  },
                ],
                staticClass: "field-input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("novelCreatePage.titleInput.placeholder"),
                  autofocus: "",
                  maxlength: "80",
                },
                domProps: { value: _vm.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.title = $event.target.value
                  },
                },
              }),
              _c("span", { staticClass: "field-hint" }, [
                _vm._v(
                  _vm._s(_vm.$t("novelCreatePage.titleInput.description"))
                ),
              ]),
            ]),
            _c("div", { staticClass: "px-1 section" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("novelCreatePage.genreCategory.label"))),
              ]),
              _c("span", { staticClass: "field-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("novelCreatePage.genreCategory.categoryLabel"))
                ),
              ]),
              _c(
                "select",
                {
                  staticClass: "field-select",
                  class: { "placeholder-selected": !_vm.genre },
                  domProps: {
                    value: _vm.genre
                      ? typeof _vm.genre === "string"
                        ? _vm.genre
                        : _vm.genre.id
                      : "",
                  },
                  on: { change: _vm.onChangeGenre },
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("novelCreatePage.genreCategory.genrePlaceholder")
                      )
                    ),
                  ]),
                  _vm._l(_vm.translatedGenreList, function (item) {
                    return _c(
                      "option",
                      { key: item.id, domProps: { value: item.id } },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    )
                  }),
                ],
                2
              ),
              _c("span", { staticClass: "field-label mt-section" }, [
                _vm._v(
                  _vm._s(_vm.$t("novelCreatePage.genreCategory.genreLabel"))
                ),
              ]),
              _c(
                "div",
                { staticClass: "genre-chips" },
                _vm._l(_vm.translatedCategoryList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "genre-chip",
                      class: {
                        selected: _vm.isCategorySelected(item),
                        disabled:
                          !_vm.isCategorySelected(item) &&
                          _vm.categories !== null &&
                          _vm.categories.length >= _vm.maxCategoryCount,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleCategory(item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  )
                }),
                0
              ),
            ]),
            _c("div", { staticClass: "px-1 section" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("novelCreatePage.wordLength.label"))),
              ]),
              _c("span", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("novelCreatePage.wordLength.fieldLabel"))),
              ]),
              _c("div", { staticClass: "word-length-row" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.wordLength,
                      expression: "wordLength",
                    },
                  ],
                  staticClass: "field-input",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t(
                      "novelCreatePage.wordLength.placeholder"
                    ),
                    maxlength: "18",
                  },
                  domProps: { value: _vm.wordLength },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.wordLength = $event.target.value
                    },
                  },
                }),
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("novelCreatePage.wordLength.suffix"))),
                ]),
              ]),
              _c("p", {
                staticClass: "field-hint field-hint--sm",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("novelCreatePage.wordLength.description")
                  ),
                },
              }),
              _c("p", { staticClass: "reference-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("novelCreatePage.wordLength.referenceLabel"))
                ),
              ]),
              _c(
                "p",
                { staticClass: "field-hint field-hint--sm field-hint--normal" },
                [_vm._v(_vm._s(_vm.$t("novelCreatePage.wordLength.reference")))]
              ),
            ]),
            _c("div", { staticClass: "section-divider" }),
            _c("div", { staticClass: "px-1 py-1\\/2 script-mode-section" }, [
              _c("label", { staticClass: "toggle-row" }, [
                _c("span", { staticClass: "toggle-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.isScriptMode,
                        expression: "isScriptMode",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.isScriptMode)
                        ? _vm._i(_vm.isScriptMode, null) > -1
                        : _vm.isScriptMode,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.isScriptMode,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.isScriptMode = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isScriptMode = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isScriptMode = $$c
                        }
                      },
                    },
                  }),
                  _c("span", { staticClass: "toggle-slider" }),
                ]),
                _c("span", { staticClass: "toggle-label" }, [
                  _vm._v(_vm._s(_vm.$t("novelCreatePage.scriptMode.label"))),
                ]),
              ]),
              _c("div", { staticClass: "toggle-description" }, [
                _c("p", { staticClass: "toggle-description-text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("novelCreatePage.scriptMode.description"))
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "toggle-link",
                    on: { click: _vm.showScriptModeHelp },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("novelCreatePage.scriptMode.learnMore")) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "submit-area" }, [
            _c(
              "button",
              {
                staticClass: "submit-btn",
                attrs: { type: "submit", disabled: !_vm.canSubmit },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onCreateButtonClick.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("novelCreatePage.submitButton")) + " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "skip-btn",
                attrs: { type: "button" },
                on: { click: _vm.onSkipStart },
              },
              [_vm._v(" " + _vm._s(_vm.$t("novelCreatePage.skipButton")) + " ")]
            ),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }